




































































import {
  defineComponent, onMounted, reactive, Ref, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import {
  createBudget,
  createExpense,
  getBudgets,
} from '@/api/index';
import useCost from '@/use/useCost';
import { Budget } from '@/types/budget';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import PartExpense from '@/components/Job/PartExpense.vue';
import useAuth from '@/use/useAuth';

const PanelWithExpenseDetail = defineComponent({
  components: {
    PartExpense,
    CommonModalWithPreset,
  },
  setup(props, { emit, root }) {
    const { route } = useRouter();
    const successModal = ref(null);
    const editExpenseModal = ref(null);
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const { defaultCostType } = useCost();
    const form = reactive({
      id: -1,
      type: '',
      name: '',
      description: '',
      amount: 0,
      call: async () => {
        if (form.id !== -1) {
          // const result = await updateExpense(form.id, {
          //   type: form.type,
          //   description: form.description,
          //   amount: form.amount,
          // });
        } else {
          let createCategoryResult = null;
          let costTypeId = -1;
          const constTypeIdIndex = availableCostsDisplay.value.indexOf(form.type);
          if (constTypeIdIndex > -1) costTypeId = availableCosts.value[constTypeIdIndex].id || -1;
          if (costTypeId === -1) {
            createCategoryResult = (await createBudget({
              bomId: route.value.params.id,
              category: form.type === 'OTHER' ? 'OTHER' : availableCosts.value[constTypeIdIndex].category,
              name: form.type === 'OTHER' ? form.name : availableCosts.value[constTypeIdIndex].name,
              cost: 0,
            })).data;
          }
          const result = await createExpense(
            costTypeId === -1 ? createCategoryResult.id : availableCosts.value[availableCostsDisplay.value.indexOf(form.type)].id,
            {
              description: form.description,
              amount: form.amount,
            },
          );
        }
        (editExpenseModal.value as any).close();
        clear();
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
        await getCostsInformation();
        emit('pendingRefetchQuery');
      },
      state: {
        value: 'READY',
      },
    });

    function clear() {
      form.id = -1;
      form.type = '';
      form.description = '';
      form.name = '';
      form.amount = 0;
    }

    const filter = reactive({
      type: undefined,
    });
    const expenses: Ref<{ name: string; category: string; usage: number; total: number; expenses: { description: string; amount: 0 }[] }[]> = ref([]);

    const availableCostsList = ref(defaultCostType.map((type: any) => type.category));
    const availableCosts = ref(defaultCostType);
    const availableCostsDisplay = ref(defaultCostType.map((type: any) => type.name));
    // ====== Format Cost result into select list
    function resultToSelectCost(budgetsArrayResult: Budget[]) {
      const hitIndex: number[] = [];
      budgetsArrayResult.forEach((budgetResult: Budget, budgetIndex: number) => {
        availableCostsDisplay.value.forEach((budget: string, index: number) => {
          if (budget === budgetResult.name && hitIndex.indexOf(budgetIndex) === -1) {
            hitIndex.push(budgetIndex);
            availableCosts.value.splice(index, 1, {
              ...budgetResult,
            });
          }
        });
      });

      budgetsArrayResult.forEach((budgetResult: Budget, budgetIndex: number) => {
        if (hitIndex.indexOf(budgetIndex) === -1) {
          availableCosts.value.push({ id: -1, ...budgetResult });
          availableCostsList.value.push(budgetResult.category);
          availableCostsDisplay.value.push(budgetResult.name);
        }
      });
    }
    async function getCostsInformation() {
      const result = await getBudgets({
        filterBomId: route.value.params.id,
        withExpenses: true,
        limit: 100,
      });

      const costs = result.data.data || [];

      resultToSelectCost(costs);
      expenses.value = [];
      for (let i = 0; i < costs.length; i += 1) {
        const expen = {
          name: costs[i].name,
          category: costs[i].category,
          usage: costs[i].expenses_stats.usage,
          total: costs[i].cost,
          totalDiscount: 0,
        };

        const expensesArr = costs[i].expenses.map((expense: any) => {
          expen.totalDiscount += expense.purchase_order.discount || 0;
          return {
            id: expense.id,
            amount: expense.amount,
            description: expense.description,
            purchase_order: expense.purchase_order,
          };
        });

        expenses.value.push({
          ...expen,
          expenses: expensesArr,
        });
      }
    }

    onMounted(async () => {
      await getCostsInformation();
    });

    return {
      hasPermission,
      successModal,
      editExpenseModal,
      form,
      clear,
      filter,

      expenses,

      availableCosts,
      availableCostsList,
      availableCostsDisplay,
    };
  },
});

export default PanelWithExpenseDetail;
